export enum ModelReviewState {
  REJECTED,
  PUBLIC,
  DRAFT,
  WAITING_FOR_REVIEW,
  IN_REVIEW,
  // Set when submitting via TestFlight build
  TESTFLIGHT_PUBLIC,
  UNPUBLISHED,
  SCAN_ONLY,
  ADMINS_ONLY,
  EXPIRED,
  ARCHIVED,
  REPORTED,
}
